import tw from 'tailwind-styled-components';

// TODO: This approach is deprecated

// Fill the space between flex-box items
export const FlexFill = (tw as any).div`flex-1`;

// Standard view and content box for most pages
export const StandardView = (tw as any).div`flex flex-1 flex-col p-4 tablet:p-7 bg-[#f2f5fa] box-border overflow-y-scroll`;
export const NonScrollingView = (tw as any).div`flex flex-1 flex-col p-4 tablet:p-7 bg-[#f2f5fa] box-border overflow-y-hidden`;
export const Content = (tw as any).div`flex-1 w-full h-full flex bg-[#f2f5fa] flex-col`;

// Standard and alternate title options
export const PageTitle = (tw as any).h1`text-2xl desktop:text-3xl mb-6 desktop:mb-4 flex flex-row`;
export const SubTitle = (tw as any).h1`sans-serif font-bold text-2xl text-[#33364b] mb-10`;
// export const DialogTitle = (tw as any).h1`sans-serif font-bold text-xl text-[#33364b] mb-4`;
export const Divider = (tw as any).hr`border-t border-top-gray-300 my-5 w-full`;

// Various form layout helpers
export const FormColumns = (tw as any).div`flex flex-col tablet:flex-row gap-0 tablet:gap-12 mb-3`;
export const FormColumn = (tw as any).div`flex flex-1 flex-col`;
export const FormRow = (tw as any).div`flex flex-0 flex-col mb-4`;
export const FormLabel = (tw as any).label`block mb-1 text-[13px] font-medium text-[#33364b]`;
export const FormHint = (tw as any).p`mt-1 text-[12px] text-gray-500`;
export const FormError = (tw as any).p`text-red-600 text-[12px] mt-1`;

// Various data table layout helpers
export const DataTable = (tw as any).table`w-full border-collapse border-b border-b-gray-200 table-fixed`;
export const DataTableHead = (tw as any).thead``;
export const DataTableBody = (tw as any).tbody``;
export const DataTableHeaderRow = (tw as any).tr``;
export const DataTableRow = (tw as any).tr`my-1 border-t border-t-gray-200 bg-white py-2 px-5`;
// export const DataTableRow = (tw as any).tr`my-1 border border-gray-300 bg-white py-2 px-5`;
export const DataTableHeaderCell = (tw as any).td`whitespace-nowrap py-2 px-4 text-left font-semibold text-[#5c6575]`;
export const DataTableDataCell = (tw as any).td`whitespace-nowrap py-2 px-4`;
